const configs = {
  server: "https://clinicaadmin.cruzvermelhatavira.pt/api/",
  // server: "https://joaopalhinha.net/cvp/api/",
  // server: "http://cvp/api/",
  sessions_to_alert: 5,
  daystransport_to_alert: 10,
};

export default configs;
